module.exports = __webpack_public_path__ + "static/media/group_26.dbfd75ab.jpg";